var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("Создание поля")]),_c('v-row',[_c('v-col',[_c('field-form',{on:{"onSubmit":_vm.store}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }